module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_09.3eb1f674.svg";